module.exports = __webpack_public_path__ + "img/ppob-ilustration-1.5dac61cd.svg";